import { render, staticRenderFns } from "./PatentContent.vue?vue&type=template&id=42150c11&scoped=true"
import script from "./PatentContent.vue?vue&type=script&lang=js"
export * from "./PatentContent.vue?vue&type=script&lang=js"
import style0 from "./PatentContent.vue?vue&type=style&index=0&id=42150c11&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42150c11",
  null
  
)

export default component.exports